/**
 * Ryan O'Dowd
 * deate
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors, globalScale, safeAreaInsets}) => {
  return {
    list: {
      paddingBottom: safeAreaInsets.bottom + 4,
    },
    reminderTextWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    timeText: {
      color: colors.white,
    },
    time: {
      color: colors.accent,
      fontSize: globalScale * 16,
    },
    timeDisplay: {
      borderBottomWidth: 3,
      borderColor: colors.primaryLight,
    },
  };
};

export default getStyles;
